import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories, categorySEO } from '@/mocks/photography';

export default function Category() {
  const [searchParams, setSearchParams] = useSearchParams();
  const typeParam = searchParams.get('type') || 'personal';
  const currentCategory = categories.find((c) => c.id === typeParam) || categories[0];
  const seo = categorySEO[typeParam] || categorySEO.personal;

  const handleCategoryChange = (id: string) => {
    setSearchParams({ type: id });
  };

  return (
    <>
      <SEOHead data={seo} />
      <ScrollToTop />
      <Navbar />
      <main>
        <div className="pt-20 pb-16 px-6 md:px-10 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: '作品分类', path: '/category' },
                { name: currentCategory.name },
              ]}
            />

            <div className="mt-4">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
                {currentCategory.name}
              </h1>
              <p className="text-foreground-600 text-sm max-w-xl">{currentCategory.description}</p>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleCategoryChange(cat.id)}
                  className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer ${
                    typeParam === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {currentCategory.works.map((work) => (
                <div
                  key={work.id}
                  className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer"
                  data-product-shop
                >
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={work.image}
                      alt={work.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-medium text-foreground-950">{work.title}</h3>
                    <p className="text-xs text-foreground-500 mt-1">{work.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {currentCategory.works.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500 text-sm">暂无作品，敬请期待</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}